import { createContext, useContext } from "react";

interface PublishContext {
    hasChanges: boolean;
    setHasChanges: (state: boolean) => void;
    needsPublishing: boolean;
    setNeedsPublishing: (state: boolean) => void;
}

export const PublishContext = createContext<PublishContext>({
    hasChanges: false,
    setHasChanges: () => {},
    needsPublishing: false,
    setNeedsPublishing: () => {},
});

export const PublishProvider = PublishContext.Provider;
export const usePublishContext = () => useContext(PublishContext);
